import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { AnimationStates } from '../animations/animation.constants';

@Injectable({ providedIn: 'root' })
export class ConsentService {
  private readonly consentSheetSubject = new BehaviorSubject<string>(AnimationStates.closed);
  readonly onConsentSheetToggle$ = this.consentSheetSubject.asObservable();

  open(): void {
    document.body.classList.add('sheet--open');
    this.consentSheetSubject.next(AnimationStates.open);
  }

  close(): void {
    document.body.classList.remove('sheet--open');
    this.consentSheetSubject.next(AnimationStates.closed);
  }
}
